import { render } from "./Wishlist.vue?vue&type=template&id=1d21df46&scoped=true"
import script from "./Wishlist.vue?vue&type=script&lang=js"
export * from "./Wishlist.vue?vue&type=script&lang=js"

import "./Wishlist.vue?vue&type=style&index=0&id=1d21df46&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d21df46"]])

export default __exports__